import {
  View,
  Image,
  TextStyle,
  TextInput,
  StyleSheet,
  TextInputProps,
} from "react-native";
import React, { PureComponent } from "react";

interface InputBoxProps
  extends Pick<
    TextInputProps,
    "value" | "editable" | "placeholder" | "onChangeText"
  > {
  rightSlot?: () => React.ReactNode;
  type: "userid" | "password" | "address";
}

export class InputBox extends PureComponent<InputBoxProps> {
  private getIcon = () => {
    switch (this.props.type) {
      case "userid":
        return require("./user.png");
      case "password":
        return require("./lock.png");
      default:
        return require("./server.png");
    }
  };

  render() {
    const inputStyles: TextStyle[] = [styles.input];
    const { type, value, onChangeText, editable, rightSlot, placeholder } =
      this.props;

    if (type == "address") {
      inputStyles.push(styles.input_address);
    } else {
      !value && inputStyles.push(styles.input_holder);
    }

    return (
      <View style={styles.container}>
        <Image style={styles.icon} source={this.getIcon()} />
        <TextInput
          style={inputStyles}
          secureTextEntry={type == "password"}
          {...{ value, editable, placeholder, onChangeText }}
        />
        {typeof rightSlot == "function" && (
          <View style={styles.right}>{rightSlot()}</View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: 50,
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 15,
    borderColor: "#eee",
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  icon: {
    width: 19,
    height: 19,
  },
  input: {
    flex: 1,
    height: "100%",
    marginLeft: 10,
    color: "#000",
    fontSize: 16,
  },
  input_holder: {
    color: "#999",
    fontSize: 14,
  },
  input_address: {
    color: "#3381e3",
    fontSize: 14,
  },
  right: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    height: "100%",
    justifyContent: "center",
  },
});
